import { useQuery } from "@tanstack/react-query";
import { getRegions } from "../services/get-regions";
import { Region } from "../types/region";

interface PaginatedRegions {
  regions: Array<Region>;
  lastPage: number;
  nextPage: number | null;
  currentPage: number;
  total: number;
}

export default function useRegions(page: number = 0, search?: string) {
  const { data, isLoading, error, isFetching, isSuccess } =
    useQuery<PaginatedRegions>({
      queryKey: ["regions", { page, search }],
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 30,
      queryFn: () => getRegions({ page, search }),
    });

  return { data, isLoading, error, isFetching, isSuccess };
}
